/**
 *  Expose all available tracking events
 */
const TrackingEventsConstants = (function() {

    const EVENT_NAME_KEY = 'real_event_name';
    const ADJUST_KEY = 'adjust';
    const TOKEN_KEY = 'token';
    const TYPE_KEY = 'type';

    /**
     * @type Array
     * Excluded providers for tracking, that's useful
     * if one specific event needs to not be sent to a given provider.
     * For example: [EXCLUSIONS_KEY]: ['Snowplow']
     * Providers can be found in the tracking-controller.js file.
     */
    const EXCLUSIONS_KEY = 'exclusions';

    return {
        'INTERFACE_LANGUAGE_SELECTED': {
            [EVENT_NAME_KEY]: 'interface_language_selected',
            [EXCLUSIONS_KEY]: []
        },
        'COURSE_SELECTED': {
            [EVENT_NAME_KEY]: 'course_selected',
            [EXCLUSIONS_KEY]: []
        },
        'PAGE_INIT': {
            [EVENT_NAME_KEY]: 'page_init',
            [EXCLUSIONS_KEY]: []
        },
        'USER_LOGIN_SUCCESS': {
            [EVENT_NAME_KEY]: 'user_login_success',
            [EXCLUSIONS_KEY]: []
        },
        'USER_LOGIN_FAILED': {
            [EVENT_NAME_KEY]: 'user_login_failed',
            [EXCLUSIONS_KEY]: []
        },
        'USER_REGISTERED_SUCCESS': {
            [EVENT_NAME_KEY]: 'user_register_success',
            [ADJUST_KEY]: {
                [TOKEN_KEY]: 'xg0m7p'
            }
        },
        'USER_REGISTERED_FAILED': {
            [EVENT_NAME_KEY]: 'user_register_failed',
            [EXCLUSIONS_KEY]: []
        },
        'VERIFICATION_CODE_PAGE_VIEWED': {
            [EVENT_NAME_KEY]: 'verification_code_page_viewed',
            [EXCLUSIONS_KEY]: []
        },
        'VERIFICATION_CODE_ENTERED': {
            [EVENT_NAME_KEY]: 'verification_code_entered',
            [EXCLUSIONS_KEY]: []
        },
        'PAGE_VIEW_HOME': {
            [EVENT_NAME_KEY]: 'homepage_view',
            [EXCLUSIONS_KEY]: []
        },
        'PAGE_VIEW_INDITEX_LANDING': {
            [EVENT_NAME_KEY]: 'inditex_landing_page_viewed',
            [EXCLUSIONS_KEY]: []
        },
        'PAGE_VIEW_COURSE_SELECTION': {
            [EVENT_NAME_KEY]: 'course_selection_viewed',
            [EXCLUSIONS_KEY]: []
        },
        'PAGE_VIEW_LOGIN_PAGE': {
            [EVENT_NAME_KEY]: 'login_page_viewed',
            [EXCLUSIONS_KEY]: []
        },
        'PAGE_VIEW_REGISTER_PAGE': {
            [EVENT_NAME_KEY]: 'registration_page_viewed',
            [EXCLUSIONS_KEY]: []
        },
        'PAGE_VIEW_PREMIUM': {
            [EVENT_NAME_KEY]: 'paywall_viewed',
            [EXCLUSIONS_KEY]: []
        },
        'PAGE_VIEW_PURCHASE': {
            [EVENT_NAME_KEY]: 'cart_entered',
            [EXCLUSIONS_KEY]: []
        },
        'PAGE_VIEW_FREE_TRIAL': {
            [EVENT_NAME_KEY]: 'free_trial_entered'
        },
        'PAGE_VIEW_AUTOAUTH': {
            [EVENT_NAME_KEY]: 'autoauth_viewed',
            [EXCLUSIONS_KEY]: []
        },
        'PURCHASE_METHOD_SELECTED': {
            [EVENT_NAME_KEY]: 'cart_psp_change',
            [EXCLUSIONS_KEY]: []
        },
        'PURCHASE_FAILURE': {
            [EVENT_NAME_KEY]: 'purchase_failed',
            [EXCLUSIONS_KEY]: []
        },
        'PURCHASE_SUCCESS': {
            [EVENT_NAME_KEY]: 'purchase_success',
            [ADJUST_KEY]: {
                [TOKEN_KEY]: 'cqr8l8',
                [TYPE_KEY]: 'ADJUST_PURCHASE_SUCCESS'
            }
        },
        'AUTOAUTH_SUCCESS': {
            [EVENT_NAME_KEY]: 'autoauth_success',
            [EXCLUSIONS_KEY]: []
        },
        'PAYWALL_SEEPLANS_CLICKED': {
            [EVENT_NAME_KEY]: 'paywall_see_all_plans_clicked',
            [EXCLUSIONS_KEY]: []
        },
        'STUDY_PLAN_CONFIRMED': {
            [EVENT_NAME_KEY]: 'study_plan_confirmed',
            [EXCLUSIONS_KEY]: []
        },
        'CAPTCHA_STARTED': {
            [EVENT_NAME_KEY]: 'captcha_started',
            [EXCLUSIONS_KEY]: []
        },
        'CAPTCHA_PASSED': {
            [EVENT_NAME_KEY]: 'captcha_passed',
            [EXCLUSIONS_KEY]: []
        },
        'CAPTCHA_NOT_PASSED': {
            [EVENT_NAME_KEY]: 'captcha_not_passed',
            [EXCLUSIONS_KEY]: []
        },
        'FAST_CHECKOUT_STARTED': {
            [EVENT_NAME_KEY]: 'fast_checkout_started',
            [EXCLUSIONS_KEY]: []
        },
        'UNSUBSCRIBE_COMMS_CLICKED': {
            [EVENT_NAME_KEY]: 'unsubscribe_comms_clicked',
            [EXCLUSIONS_KEY]: []
        },
        'PAYWALL_PLAN_DURATION_CHANGED': {
            [EVENT_NAME_KEY]: 'paywall_plan_length_changed',
            [EXCLUSIONS_KEY]: []
        },
        'LEARNER_TYPE_VIEWED': {
            [EVENT_NAME_KEY]: 'learner_type_chooser_viewed',
            [EXCLUSIONS_KEY]: []
        },
        'CHOOSE_YOUR_PLAN_VIEWED': {
            [EVENT_NAME_KEY]: 'post_register_premium_offering_viewed',
            [EXCLUSIONS_KEY]: []
        },
        'CHOOSE_PLAN_SELECTED_FREE': {
            [EVENT_NAME_KEY]: 'post_register_premium_offering_free_clicked',
            [EXCLUSIONS_KEY]: []
        },
        'CHOOSE_PLAN_SELECTED_PREMIUM': {
            [EVENT_NAME_KEY]: 'post_register_premium_offering_premium_clicked',
            [EXCLUSIONS_KEY]: []
        },
        'REFERRAL_LANDING_PAGE_VIEWED': {
            [EVENT_NAME_KEY]: 'referral_landing_page_viewed',
            [EXCLUSIONS_KEY]: []
        },
        'REFERRAL_LANDING_PAGE_CTA_SELECTED': {
            [EVENT_NAME_KEY]: 'referral_landing_page_cta_selected',
            [EXCLUSIONS_KEY]: []
        },
        'APP_STORE_BADGE_SELECTED': {
            [EVENT_NAME_KEY]: 'app_store_badge_selected',
            [EXCLUSIONS_KEY]: []
        },
        'LIVE_MARKETING_PAGE_VIEWED': {
            [EVENT_NAME_KEY]: 'live_marketing_page_viewed',
            [EXCLUSIONS_KEY]: []
        },
        'CJ_AFFILIATE_COOKIE': {
            [EVENT_NAME_KEY]: 'cj_afilliate_cookie_received',
            [EXCLUSIONS_KEY]: []
        },
        'LIVE_VIEW_PRICING_CLICKED': {
            [EVENT_NAME_KEY]: 'live_view_pricing_clicked',
            [EXCLUSIONS_KEY]: []
        },
        'LIVE_FINDTEACHER_CLICKED': {
            [EVENT_NAME_KEY]: 'live_findteacher_clicked',
            [EXCLUSIONS_KEY]: []
        },
        'LIVE_HEADER_FLAG_CLICKED': {
            [EVENT_NAME_KEY]: 'live_header_flag_clicked',
            [EXCLUSIONS_KEY]: []
        },
        'CANCEL_FREE_TRIAL_CLICKED': {
            [EVENT_NAME_KEY]: 'free_trial_cancelled',
            [EXCLUSIONS_KEY]: []
        },
        'FREE_TRIAL_STARTED': {
            [EVENT_NAME_KEY]: 'free_trial_started',
            [EXCLUSIONS_KEY]: []
        }
    };
})();

export default TrackingEventsConstants;
